import ChangeListener from './ChangeListener';

export default class ChangeListenerList {
  private listeners: ChangeListener[] = [];

  public addListener(listener: ChangeListener): void {
    this.listeners.push(listener);
  }

  public removeListener(listener: ChangeListener): void {
    this.listeners.splice(this.listeners.indexOf(listener), 1);
  }

  public notifyListenersAboutChange(): void {
    this.listeners.forEach((listener) => listener.onChanged());
  }
}
